import React, { useState } from 'react';
import { XIcon, TrashIcon, PlusIcon, MinusIcon, ShoppingBagIcon, ArrowRightIcon } from 'lucide-react';
import { useStore } from '../hooks/useStore';
type CartProps = {
  isOpen: boolean;
  onClose: () => void;
};
export function Cart({
  isOpen,
  onClose
}: CartProps) {
  const {
    cart,
    removeFromCart,
    updateCartQuantity,
    cartTotal,
    placeOrder
  } = useStore();
  const [customerName, setCustomerName] = useState('');
  const [customerPhone, setCustomerPhone] = useState('');
  const [orderType, setOrderType] = useState<'delivery' | 'pickup'>('pickup');
  const [isOrdering, setIsOrdering] = useState(false);
  const [success, setSuccess] = useState(false);
  if (!isOpen) return null;
  const handlePlaceOrder = (e: React.FormEvent) => {
    e.preventDefault();
    if (!customerName || !customerPhone) return;
    placeOrder(customerName, customerPhone, orderType);
    setIsOrdering(false);
    setCustomerName('');
    setCustomerPhone('');
    setSuccess(true);
    setTimeout(() => {
      setSuccess(false);
      onClose();
    }, 2500);
  };
  return <div className="fixed inset-0 z-[60] flex justify-end" data-id="element-58">
      <div className="absolute inset-0 bg-black/30 backdrop-blur-sm" onClick={onClose} data-id="element-59"></div>

      <div className="relative w-full max-w-md bg-white h-full shadow-2xl flex flex-col" data-id="element-60">
        <div className="p-5 border-b border-stone-200 flex items-center justify-between" data-id="element-61">
          <h2 className="font-display text-lg text-[#1c1917]" data-id="element-62">Tu Pedido</h2>
          <button onClick={onClose} className="p-2 hover:bg-stone-100 rounded-lg transition-colors" data-id="element-63">
            <XIcon className="w-5 h-5" data-id="element-64" />
          </button>
        </div>

        {success ? <div className="flex-1 flex flex-col items-center justify-center text-center p-8" data-id="element-65">
            <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mb-4" data-id="element-66">
              <svg className="w-8 h-8 text-emerald-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-67">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-68" />
              </svg>
            </div>
            <h3 className="font-display text-2xl text-[#1c1917] mb-2" data-id="element-69">
              ¡Pedido Enviado!
            </h3>
            <p className="text-stone-500 text-sm" data-id="element-70">
              Te contactaremos para confirmar.
            </p>
          </div> : <>
            <div className="flex-1 overflow-y-auto p-5" data-id="element-71">
              {cart.length === 0 ? <div className="h-full flex flex-col items-center justify-center text-center" data-id="element-72">
                  <div className="w-16 h-16 bg-stone-100 rounded-full flex items-center justify-center mb-4" data-id="element-73">
                    <ShoppingBagIcon className="w-7 h-7 text-stone-400" data-id="element-74" />
                  </div>
                  <p className="font-semibold text-[#1c1917] mb-1" data-id="element-75">
                    Carrito vacío
                  </p>
                  <p className="text-stone-400 text-sm mb-6" data-id="element-76">
                    Añade platos desde el menú
                  </p>
                  <button onClick={onClose} className="px-5 py-2.5 bg-black text-white rounded-lg font-semibold text-sm hover:bg-[#262626]" data-id="element-77">
                    Explorar Menú
                  </button>
                </div> : <div className="space-y-4" data-id="element-78">
                  {cart.map(item => <div key={item.menuItem.id} className="flex gap-4 pb-4 border-b border-stone-100 last:border-0" data-id="element-79">
                      <div className="flex-1" data-id="element-80">
                        <h3 className="font-semibold text-[#1c1917]" data-id="element-81">
                          {item.menuItem.name}
                        </h3>
                        <p className="text-sm text-stone-500" data-id="element-82">
                          ${(item.menuItem.price * item.quantity).toFixed(2)}
                        </p>
                      </div>
                      <div className="flex items-center gap-2" data-id="element-83">
                        <div className="flex items-center bg-stone-100 rounded-lg" data-id="element-84">
                          <button onClick={() => updateCartQuantity(item.menuItem.id, item.quantity - 1)} className="p-2 hover:bg-stone-200 rounded-l-lg" data-id="element-85">
                            <MinusIcon className="w-3 h-3" data-id="element-86" />
                          </button>
                          <span className="w-7 text-center text-sm font-bold" data-id="element-87">
                            {item.quantity}
                          </span>
                          <button onClick={() => updateCartQuantity(item.menuItem.id, item.quantity + 1)} className="p-2 hover:bg-stone-200 rounded-r-lg" data-id="element-88">
                            <PlusIcon className="w-3 h-3" data-id="element-89" />
                          </button>
                        </div>
                        <button onClick={() => removeFromCart(item.menuItem.id)} className="p-2 text-stone-400 hover:text-red-500 hover:bg-red-50 rounded-lg" data-id="element-90">
                          <TrashIcon className="w-4 h-4" data-id="element-91" />
                        </button>
                      </div>
                    </div>)}
                </div>}
            </div>

            {cart.length > 0 && <div className="p-5 border-t border-stone-200 bg-stone-50" data-id="element-92">
                <div className="space-y-2 mb-4" data-id="element-93">
                  <div className="flex justify-between items-center text-sm" data-id="element-94">
                    <span className="text-stone-500 font-medium" data-id="element-95">
                      Subtotal (sin ITBIS)
                    </span>
                    <span className="font-semibold text-stone-700" data-id="element-96">
                      RD$ {(cartTotal / 1.18).toFixed(2)}
                    </span>
                  </div>
                  <div className="flex justify-between items-center text-sm" data-id="element-97">
                    <span className="text-stone-500 font-medium" data-id="element-98">
                      ITBIS (18%)
                    </span>
                    <span className="font-semibold text-stone-700" data-id="element-99">
                      RD$ {(cartTotal - cartTotal / 1.18).toFixed(2)}
                    </span>
                  </div>
                  <div className="h-px bg-stone-200 my-1" data-id="element-100" />
                  <div className="flex justify-between items-center" data-id="element-101">
                    <span className="text-sm font-bold text-stone-900" data-id="element-102">
                      Total
                    </span>
                    <span className="text-2xl font-bold text-stone-900" data-id="element-103">
                      RD$ {cartTotal.toFixed(2)}
                    </span>
                  </div>
                </div>

                {!isOrdering ? <button onClick={() => setIsOrdering(true)} className="w-full py-3.5 bg-black text-white rounded-xl font-semibold text-sm hover:bg-[#262626] transition-colors flex items-center justify-center gap-2" data-id="element-104">
                    Continuar <ArrowRightIcon className="w-4 h-4" data-id="element-105" />
                  </button> : <form onSubmit={handlePlaceOrder} className="space-y-3" data-id="element-106">
                    <input type="text" required value={customerName} onChange={e => setCustomerName(e.target.value)} className="w-full p-3 bg-white border border-stone-200 rounded-xl text-sm focus:ring-2 focus:ring-black/10 focus:border-black outline-none" placeholder="Tu nombre" data-id="element-107" />
                    <input type="tel" required value={customerPhone} onChange={e => setCustomerPhone(e.target.value)} className="w-full p-3 bg-white border border-stone-200 rounded-xl text-sm focus:ring-2 focus:ring-black/10 focus:border-black outline-none" placeholder="Tu teléfono" data-id="element-108" />
                    <div className="grid grid-cols-2 gap-2" data-id="element-109">
                      {(['pickup', 'delivery'] as const).map(type => <label key={type} className={`flex items-center justify-center p-3 border rounded-xl cursor-pointer transition-all text-sm font-semibold ${orderType === type ? 'border-black bg-black text-white' : 'border-stone-200 bg-white text-stone-600 hover:border-stone-300'}`} data-id="element-110">
                          <input type="radio" name="type" checked={orderType === type} onChange={() => setOrderType(type)} className="hidden" data-id="element-111" />
                          {type === 'pickup' ? 'Recoger' : 'Delivery'}
                        </label>)}
                    </div>
                    <div className="flex gap-2 pt-2" data-id="element-112">
                      <button type="button" onClick={() => setIsOrdering(false)} className="flex-1 py-3 border border-stone-200 text-stone-500 font-semibold text-sm rounded-xl hover:bg-white" data-id="element-113">
                        Volver
                      </button>
                      <button type="submit" className="flex-1 py-3 bg-black text-white font-semibold text-sm rounded-xl hover:bg-[#262626]" data-id="element-114">
                        Confirmar
                      </button>
                    </div>
                  </form>}
              </div>}
          </>}
      </div>
    </div>;
}